import React from 'react';
import { Alert } from '../alert/Alert';
import { ListErrors } from './ListErrors';

export const ErrorMessage = ({ children, className, onDismiss }: Props) => {

    if (children.length === 0) {
        return null;
    }

    return (
        <Alert type='error' icon='alert-triangle-exclamation' className={className} onDismiss={onDismiss}>
            <ListErrors errors={children} />
        </Alert>
    );
};

type Props = {
    children: string[];
    className?: string;
    onDismiss?: () => void;
};